import {Reducer} from "redux";
import { SkillTagState } from "../store/skill_tag_state";
import { 
    SkillTagAction, 
    SingleSkillTagActionType, 
    MultiSkillTagActionType,

    ICallbackGetSingleSkillTagListAction, 
    ICallbackGetMultiSkillTagListAction,
    ICallbackGetOccupationSkillTagListAction,
    OccupationSkillTagActionType} from '../action/skill_tag_action';

const initialState: SkillTagState = {
    singleSkillTags: [],
    multiSkillTags: [],
    occupationSkillTags: [],
    isLoading: false,
};

const skillTagReducer: Reducer<SkillTagState> = (state = initialState, action: SkillTagAction): SkillTagState => {
    switch (action.type) {

        // single
        case SingleSkillTagActionType.REQUSET_GET_SINGLE_SKILL_TAG_LIST: {
            return Object.assign({}, state, {
                singleSkillTag: state.singleSkillTags,
                isLoading: true,
            });
        }
        case SingleSkillTagActionType.CALLBACK_GET_SINGLE_SKILL_TAG_LIST: {
            const _action = action as ICallbackGetSingleSkillTagListAction;
            if (action.isSuccess) {
                return Object.assign({}, state, {
                    singleSkillTags: _action.item ? _action.item.singleSkillTags : null,
                    isLoading: false,
                });
            } else {
                return Object.assign({}, state, {
                    singleSkillTags: state.singleSkillTags,
                    isLoading: false,
                });
            }
        }


        // multi
        case MultiSkillTagActionType.REQUSET_GET_MULTI_SKILL_TAG_LIST: {
            return Object.assign({}, state, {
                multiSkillTags: state.multiSkillTags,
                isLoading: true,
            });
        }
        case MultiSkillTagActionType.CALLBACK_GET_MULTI_SKILL_TAG_LIST: {
            const _action = action as ICallbackGetMultiSkillTagListAction;
            if (action.isSuccess) {
                return Object.assign({}, state, {
                    multiSkillTags: _action.item ? _action.item.multiSkillTags : null,
                    isLoading: false,
                });
            } else {
                return Object.assign({}, state, {
                    multiSkillTags: state.multiSkillTags,
                    isLoading: false,
                });
            }
        }

        // occupation
        case OccupationSkillTagActionType.REQUSET_GET_OCCUPATION_SKILL_TAG_LIST: {
            return Object.assign({}, state, {
                occupationSkillTags: state.occupationSkillTags,
                isLoading: true,
            });
        }
        case OccupationSkillTagActionType.CALLBACK_GET_OCCUPATION_SKILL_TAG_LIST: {
            const _action = action as ICallbackGetOccupationSkillTagListAction;
            if (action.isSuccess) {
                return Object.assign({}, state, {
                    occupationSkillTags: _action.item ? _action.item.occupationSkillTags : null,
                    isLoading: false,
                });
            } else {
                return Object.assign({}, state, {
                    multiSkillTags: state.multiSkillTags,
                    isLoading: false,
                });
            }
        }

        default:
            return state;
    }
};

export default skillTagReducer;



// WEBPACK FOOTER //
// ./src/presentation/reducer/skill_tag_reducer.ts